/**
 * Created by Jasmine on 2019/1/3.
 */
import { observable, action } from 'mobx'
import moment from 'moment'
import { apis, request } from '../../../utils/net'

class Store {

    // 导入查询数据
    @observable subordinate_shop = [];

    @observable duty_paragraph = [{
        text: '全部',
        id: 0
    }, {
        text: '123',
        id: 1
    }, {
        text: '456',
        id: 2
    }];

    @observable out_invoice_type = [{
        text: '全部',
        id: ''
    }, {
        text: '未开票',
        id: 0
    }, {
        text: '已发起开票',
        id: 1
    }, {
        text: '开票中',
        id: 2
    }, {
        text: '已完成',
        id: 3
    }]

    @observable getSubordinateShop() {
        request({
            url: apis.getSysShops,
            method: 'GET',
        }).then(res => {
            this.subordinate_shop = [{
                name: '全部',
                id: ''
            }, ...res];
        });
    }
    @observable getDutyParagraph() {
        request({
            url: apis.getTaxList,
            method: 'GET',
        }).then(res => {
            this.duty_paragraph = [{
                tax_num: '全部',
                invoice_tax_num: ''
            }, ...res]
        });
    }

    // 查询批量导入记录数据与批量开票记录数据
    @observable formData = {
        begin_at: moment().startOf('month').unix(),         //起始时间戳
        end_at: moment().endOf('day').unix(),          //终止时间戳
        store_name: '',     //门店名称
        tax_num: '',   //税盘号
        status: ''    //状态
    }

    // 获取批量导入记录列表
    @observable batExportRecordList = [];
    @observable batExportRecordPage = 1;
    @observable batExportRecordTotal = 0;

    @action getbatExportRecord(page, page_size = 10) {
        return request({
            url: apis.batExportRecord,
            method: 'POST',
            data: {
                ...this.formData,
                page: page || this.batExportRecordPage,
                page_size
            }
        }).then(res => {
            // this.batExportRecordList = res
            //    分页暂时没有
            this.batExportRecordList = res.list
            this.batExportRecordPage = res.page
            this.batExportRecordTotal = +res.total_count
        })
    }

    // 获取批量开票记录
    @observable batRecordList = []
    @observable batRecordPage = 1
    @observable batRecordtotal = 0

    @action getBatRecord(page, page_size = 10) {
        return request({
            url: apis.batRecord,
            method: 'POST',
            data: {
                ...this.formData,
                page: page || this.batRecordPage,
                page_size
            }
        }).then(res => {
            // this.BatRecordList = res
            //    分页暂时没有
            this.batRecordList = res.list
            this.batRecordPage = res.page
            this.batRecordtotal = +res.total_count
        })
    }

    // 下载批量开具发票模板
    @action getDownloadBatExport() {
        request({
            url: apis.downloadBatExport,
        }).then(res => {
        })
    }

    // 批量发起开票
    @observable getBatInvoice(params) {
        return request({
            url: apis.batInvoice,
            method: 'GET',
            data: { id: params },
        }).then(res => {
            return true
        })
    }

    @observable getBatTimesType = false

    // 获取批开次数
    @action getBatTimes() {
        return request({
            url: apis.getBatTimes,
            method: 'GET'
        }).then(res => {
            this.getBatTimesType = res > 0 ? false : true
        })
    }

    // 导入明细数据
    @observable.shallow uploadData = {
        list: [],
        failure_num: 0
    }

    // 导入批量开票excel数据上传
    @action handleUploadData(res) {
        this.uploadData = res.data || {}
    }


}

export default new Store()
